var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCheckFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 96,
    width: 471,
    height: 319,
    rx: 20,
    fill: "#F2FCEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449 95.25C344 319.25 206.333 412.417 125 415.25H477C489 415.25 491.667 405.25 491.5 400.25V112.25C490.5 105.25 486.656 99.3126 479 96.25C474 94.25 461.5 95.25 449 95.25Z",
    fill: "#D9E3D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343 186H180C175.582 186 172 189.582 172 194C172 198.418 175.582 202 180 202H343C347.418 202 351 198.418 351 194C351 189.582 347.418 186 343 186Z",
    fill: "#7B9972"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366 158H180C175.582 158 172 161.582 172 166C172 170.418 175.582 174 180 174H366C370.418 174 374 170.418 374 166C374 161.582 370.418 158 366 158Z",
    fill: "#7B9972"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223 326H70C65.5817 326 62 329.582 62 334C62 338.418 65.5817 342 70 342H223C227.418 342 231 338.418 231 334C231 329.582 227.418 326 223 326Z",
    fill: "#7B9972"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212 354H70C65.5817 354 62 357.582 62 362C62 366.418 65.5817 370 70 370H212C216.418 370 220 366.418 220 362C220 357.582 216.418 354 212 354Z",
    fill: "#7B9972"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M412 354H276C271.582 354 268 357.582 268 362C268 366.418 271.582 370 276 370H412C416.418 370 420 366.418 420 362C420 357.582 416.418 354 412 354Z",
    fill: "#7B9972"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M342.231 274.125L319.103 284.4L318.336 336.866L362.614 314.928L362.008 288.001L342.231 274.125Z",
    fill: "#8A9685",
    stroke: "#8A9685",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370.894 290.179L337.407 268.329L346.771 253.978L380.258 275.827L370.894 290.179Z",
    fill: "#DBA053",
    stroke: "#DBA053",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M349.01 300.119C348.091 295.753 343.808 292.958 339.442 293.876C335.076 294.795 332.281 299.078 333.199 303.444C334.118 307.81 338.401 310.605 342.767 309.687C347.133 308.769 349.928 304.485 349.01 300.119Z",
    fill: "#D9E3D5",
    stroke: "#1A1A4D",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313 344L341 302Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M313 344L341 302",
    stroke: "#D9E3D5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M490.128 94.3443L381.328 261.098L359.484 246.846L468.284 80.0924C472.22 74.0606 480.3 72.3612 486.332 76.2967C492.364 80.2323 494.063 88.3125 490.128 94.3443Z",
    fill: "#1A1A4D",
    stroke: "#1A1A4D",
    strokeWidth: 8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 135.958V223.042",
    stroke: "#327527",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.292 151.792H99.6042C95.9298 151.792 92.406 153.251 89.8078 155.849C87.2096 158.448 85.75 161.971 85.75 165.646C85.75 169.32 87.2096 172.844 89.8078 175.442C92.406 178.04 95.9298 179.5 99.6042 179.5H119.396C123.07 179.5 126.594 180.96 129.192 183.558C131.79 186.156 133.25 189.68 133.25 193.354C133.25 197.029 131.79 200.552 129.192 203.151C126.594 205.749 123.07 207.208 119.396 207.208H85.75",
    stroke: "#327527",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCheckFlat);
export default __webpack_public_path__ + "static/media/bank-check-flat.b2a37f8c2d3e6e30e68ab8f46236709d.svg";
export { ForwardRef as ReactComponent };